
import { useEffect, useRef, useState } from "react";  
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../style/style-cv-1.css';
import { faCloudDownload, faEdit } from "@fortawesome/free-solid-svg-icons";  
import Cookies from 'js-cookie';
import axios from '../axios/axios';   
import CVTemplate1 from "../components/consulter-cv-new-temp";
import CVTemplate2 from "../components/consulter-cv-annc-template";
import { Link, useNavigate, useParams } from "react-router-dom";
import ChoisireTemplate from "../components/choisire-template";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default function ConsulterCvAdmin() { 
    const navigate = useNavigate();
    const { idCV } = useParams();
    const pdfRef = useRef();

    const [choisireTemplate, setChoisireTemplate] = useState(0);
    const token = Cookies.get('auth_token');
    const [user, setUser] = useState({});
    const [cv, setCv] = useState({});
    const [formations, setFormations] = useState([]);
    const [experiences, setExperiences] = useState([]);
    const [langues, setLangues] = useState([]);
    const [competences, setCompetences] = useState([]);
    const [piecejointes, setPiecejointes] = useState([]);
    const [chargement, setChargement] = useState(false);

    useEffect(() => {
        getCv();
    }, []);   


    const getCv = () => {
        setChargement(true)
        axios.get(`/consultCvPourAdmin/${idCV}`,{
            headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            
            if(response.data.cv == null && response.data.user.role == 1){
                navigate(`${process.env.PUBLIC_URL}/rim`)
            }else{
                setUser(response.data.user);
                setCv(response.data.cv);
                setFormations(response.data.formations);
                setExperiences(response.data.experiences);
                setLangues(response.data.langues);
                setCompetences(response.data.skills);
                setPiecejointes(response.data.ps);
                setChargement(false)
            }

        }).catch((err) => {
            console.log(err);
            
        });

    }


    const changerTemplate = (num) => {
        setChoisireTemplate(num)
    }
    

    const suprimerExperience = (id) => { 
        axios.get(`/suprimerExperience/${id}`,{
            headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => { 
            getCv()  
        }).catch((err) => {
            console.log(err);  
        }); 
    }

    const suprimerFormation = (id) => {

        axios.get(`/suprimerFormation/${id}`,{
            headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => { 
            getCv() 

        }).catch((err) => {
            console.log(err); 
            
        });

    }

    const suprimerLangue = (id) => { 
        axios.get(`/suprimerLangue/${id}`,{
            headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => { 
            getCv() 

        }).catch((err) => {
            console.log(err); 
            
        });

    }


    const suprimerCompetence = (id) => { 
        axios.get(`/suprimerCompetence/${id}`,{
            headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => { 
            getCv() 

        }).catch((err) => {
            console.log(err); 
            
        });

    }

    const editeCV = (e) => {
      Cookies.remove('addPJ');
      navigate(`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`);
    }
    

    const downloadPdf = () => {
         const input = document.getElementById('pdf-content');

        html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

        // Check if content exceeds one page
        if (canvas.height > 290) { // A4 height in pixels
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, -297, imgWidth, imgHeight);
        }

        pdf.save('cv-' + cv.nom + '.pdf');
        });
    };

    return (
        chargement == true ? 
            
            <div className="container card text-center mt-5">
              <h4>Chargement .... </h4>
            </div>

            :
            <>

                <ChoisireTemplate changerTemplate={changerTemplate} />
                
                <div className="container-fluid overcover">
                        <div className="container profile-box">

                        <div className="rt-div">
                            <div className="rit-cover">
                                <div className="about">
                                    <div className="btn-ro row ">
                                        <ul className="btn-link" style={{listStyleType:'none'}}>
                                            <li style={{borderBlockColor: "#00ab9f"}}> 
                                                <a style={{color : "#00ab9f", cursor:'pointer'}} onClick={editeCV} >
                                                    <FontAwesomeIcon icon={faEdit}  /> Modifier
                                                </a> 
                                            </li>

                                            <li>
                                                <Link style={{color : "#888"}}  onClick={downloadPdf} to="">
                                                    <FontAwesomeIcon icon={faCloudDownload}  /> Télécharger votre CV en pdf
                                                </Link>
                                                
                                            </li> 
                                        </ul>
                                    </div>
                                </div>
                            </div> 
                        </div>
                        <div id="pdf-content" style={{padding:'10px'}}>
                            {choisireTemplate == 0 ? 
                            <CVTemplate1 cv={cv} formations={formations} experiences={experiences} competences={competences} langues={langues} 
                                            piecejointes={piecejointes} suprimerExperience={suprimerExperience} suprimerFormation={suprimerFormation}
                                            suprimerLangue={suprimerLangue} suprimerCompetence={suprimerCompetence}/>
                            : <CVTemplate2 cv={cv} formations={formations} experiences={experiences} competences={competences} langues={langues} piecejointes={piecejointes} 
                                            suprimerExperience={suprimerExperience} suprimerFormation={suprimerFormation}
                                            suprimerLangue={suprimerLangue} suprimerCompetence={suprimerCompetence}/>}
                        </div>

                    </div>
                </div>

            </>
        
        
    )
}